'use strict';
angular.module('app')
.service('programmes', function ()
{
    this.themes = [];
    this.translations = {};

    this.current = {
        theme: null,
        language: null
    };

    this.changed = [];

    this.setThemes = function(themes)
    {
        this.themes = themes;
    };

    this.setTranslations = function(translations)
    {
        this.translations = translations;
    };

    this.setCurrentLanguage = function (language)
    {
        this.current.language = language;
    }

    this.setCurrentTheme = function (theme)
    {
        if (this.themes.indexOf(theme) === -1) {
            theme = null;
        }

        this.current.theme = theme;

        angular.forEach(this.changed, function (f)
        {
            f(theme);
        });
    };

    this.onThemeChanged = function (f)
    {
        this.changed.push(f);
    }
});
